import { type FC } from 'react';
import * as React from 'react';

import { type BaseSvgProps, colorToHexCode, sizeToSvgWidth } from '../../utils';

export const LedgerUndeployed: FC<BaseSvgProps> = ({
  width = sizeToSvgWidth.sm,
  'data-testid': testId,
}) => (
  <svg
    width={width}
    height={width}
    className="shrink-0"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testId}
  >
    <rect
      x="6.01221"
      y="6.5"
      width="6"
      height="6"
      fill={colorToHexCode['inactive-tr']}
    />
    <rect
      x="6.01221"
      y="0.5"
      width="6"
      height="6"
      fill={colorToHexCode['inactive-tr']}
    />
    <rect
      x="0.012207"
      y="6.5"
      width="6"
      height="6"
      fill={colorToHexCode['inactive-bl']}
    />
    <rect
      x="0.012207"
      y="0.5"
      width="6"
      height="6"
      fill={colorToHexCode['inactive-tl']}
    />
  </svg>
);
